import EventEmitter from './event_emmiter.ts';

const eventEmitter = new EventEmitter();

export default eventEmitter;